var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text--primary text-body-1"},[_vm._v(_vm._s(_vm.currency)+" "+_vm._s(_vm.formatPrice(_vm.price)))]),_c('div',{staticClass:"grey--text"},[_vm._v(_vm._s(_vm.formatDate(_vm.date)))])])}
var staticRenderFns = []

export { render, staticRenderFns }